import React, { useContext } from "react";
import { FaCheckDouble, FaSearch, FaMicroscope, FaTools } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import '../Audit/AuditGlobal.css';
import BannerImage from '../../assets/core_services/ndt_services_hero_1776820084231.png';

function NDTServices() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/ndt-services');
    } else {
      navigate('/login', { state: { from: '/booking/ndt-services' } });
    }
  };

  return (
    <div className="audit-page">
      <div className="audit-max-width">

        {/* --- HERO --- */}
        <div className="audit-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Core Services</span>
          <h1 className="hero-title">NDT Services & Calibration</h1>
          <p className="hero-subtitle">
            Advanced Non-Destructive Testing and precise calibration services to ensure the integrity and accuracy of your assets.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Enquire Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Precision Without Destruction</h2>
              <p className="article-text">
                Non-Destructive Testing (NDT) is crucial for evaluating the properties of a material, component, or system without causing damage. Coupled with our calibration services, we ensure your equipment operates within precise tolerances, maximizing reliability and safety across your operations.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Our Expertise</h2>
              <p className="article-text">
                We offer a comprehensive suite of NDT methods, including:
                <br />- <strong>Ultrasonic Testing (UT):</strong> For internal flaw detection and thickness measurement.
                <br />- <strong>Radiographic Testing (RT):</strong> For volumetric inspection of welds and castings.
                <br />- <strong>Magnetic Particle Testing (MT):</strong> For surface and near-surface discontinuity detection in ferromagnetic materials.
                <br />- <strong>Liquid Penetrant Testing (PT):</strong> For surface-breaking defects in non-porous materials.
                <br />- <strong>Instrument Calibration:</strong> Ensuring measurement tools are accurate and traceable to national standards.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Why Choose Us?</h2>
              <p className="article-text">
                Our certified NDT technicians and advanced calibration laboratories provide accurate, reliable data, enabling you to make informed maintenance decisions, extend asset life, and avoid unplanned downtime.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Core Capabilities</h4>
              <ul className="key-list">
                <li><FaMicroscope className="check-icon" /> Advanced Diagnostics</li>
                <li><FaTools className="check-icon" /> Precise Calibration</li>
                <li><FaSearch className="check-icon" /> Flaw Detection</li>
                <li><FaCheckDouble className="check-icon" /> Guaranteed Accuracy</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Need Testing?</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Book our expert NDT and Calibration services today.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Schedule Service
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default NDTServices;
